// // src/context/TimezoneContext.tsx
// import { createContext, useContext, useState} from "react";

// type TimezoneContextType = {
//   timezone: string;
//   setTimezone: (tz: string) => void;
// };

// const TimezoneContext = createContext<TimezoneContextType>({
//   timezone: "UTC",
//   setTimezone: () => {},
// });

// export const TimezoneProvider = ({ children }: { children: React.ReactNode }) => {
//   const [timezone, setTimezone] = useState("UTC");

//   return (
//     <TimezoneContext.Provider value={{ timezone, setTimezone }}>
//       {children}
//     </TimezoneContext.Provider>
//   );
// };

// export const useTimezone = () => useContext(TimezoneContext);

import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "context/AuthContext";
import http from "services/httpClient";

type TimezoneContextType = {
  timezone: string;
  setTimezone: (tz: string) => void;
};

const TimezoneContext = createContext<TimezoneContextType>({
  timezone: "UTC",
  setTimezone: () => {},
});

export const TimezoneProvider = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, isLoading } = useAuth();

  const [timezone, setTimezone] = useState(
    Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC"
  );

  useEffect(() => {
    const fetchProfileTimezone = async () => {
      try {
        const res = await http.get("/user/profile/");
        const profileTimezone =
          res.data?.timezone ||
          Intl.DateTimeFormat().resolvedOptions().timeZone ||
          "UTC";

        setTimezone(profileTimezone);
      } catch {
        setTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC");
      }
    };

    if (!isLoading && isAuthenticated) {
      fetchProfileTimezone();
    }
  }, [isAuthenticated, isLoading]);

  return (
    <TimezoneContext.Provider value={{ timezone, setTimezone }}>
      {children}
    </TimezoneContext.Provider>
  );
};

export const useTimezone = () => useContext(TimezoneContext);